import React from 'react';
import { View, Text } from 'react-native';
import StatLine from './StatLine';
import styled from 'styled-components/native';
import {
  WorkoutTextHeader,
  WorkoutTextSubHeader,
  WorkoutContainerText
} from '../../../styles/common-styles.js';

function WorkoutStats({activities}) {

  //////console.log("WorkoutStats render");

  ///////console.log(activities);
  return (
    <WorkoutStatsParent style={{}}>
      <WorkoutStatsSubHeaderText>STATS</WorkoutStatsSubHeaderText>
      <WorkoutStatsHeaderText>Your Scores</WorkoutStatsHeaderText>
      <WorkoutStatsText>All scores based on 800 possible points</WorkoutStatsText>
     
      <WorkoutStatKey>
        <WorkoutStatKeySegment>
          <WorkoutStatKeyPoint style={{backgroundColor:'#87CDB3'}}></WorkoutStatKeyPoint>
          <WorkoutContainerText>Good</WorkoutContainerText>
        </WorkoutStatKeySegment>

        <WorkoutStatKeySegment>
          <WorkoutStatKeyPoint style={{backgroundColor:'#FFCB39'}}></WorkoutStatKeyPoint>
          <WorkoutContainerText>Moderate</WorkoutContainerText>          
        </WorkoutStatKeySegment>

        <WorkoutStatKeySegment>
          <WorkoutStatKeyPoint style={{backgroundColor:'#CF2D6D'}}></WorkoutStatKeyPoint>
          <WorkoutContainerText>Low</WorkoutContainerText>        
        </WorkoutStatKeySegment>
      </WorkoutStatKey>

      {activities.map((activity, index) => (
        <StatLine key={index} name={activity.name} score={activity.score}/>
      ))}

    </WorkoutStatsParent>
  );
}

export const WorkoutStatsParent = styled.View`
  width:100%;
  max-width:400px;
  height:400px;
  padding:30px;
`

export const WorkoutStatsHeaderText = styled(WorkoutTextHeader)`
`;

export const WorkoutStatsSubHeaderText = styled(WorkoutTextSubHeader)`
  margin-bottom:10px;
`;

export const WorkoutStatsText = styled(WorkoutContainerText)`
  margin-top:4px;
`;

export const WorkoutStatKey = styled.View`
  width: 100%;
  height:25px;
  background:#fdf4ee;
  border-radius:50px;
  display:flex;
  justify-content:flex-start;
  align-items:center;
  flex-direction:row;
  margin-top:15px;
  margin-bottom:15px;
`;

export const WorkoutStatKeySegment = styled.View`
  display:flex;
  justify-content:center;
  align-items:center;
  flex-direction:row;
  margin-left:15px;
  height:100%;
`;

export const WorkoutStatKeyPoint = styled.View`
  border-radius:50px;
  margin-right:5px;
  width:11px;
  height:11px;
`;

export default WorkoutStats;
